import React from 'react';
import {
  SentWithBonjoroBadgeRounded,
  SentWithBonjoroBadgeTheme,
  SentWithBonjoroBadgeOpacity,
  SentWithBonjoroBadgeSize,
  SentWithBonjoroBadge,
  SentWithBonjoroBadgeProps,
} from '@vimily/bonjoro-ui-components-v2/SentWithBonjoroBadge';

export const BonjoroBadgeDesktop = (props: SentWithBonjoroBadgeProps) => {
  return (
    <SentWithBonjoroBadge
      theme={SentWithBonjoroBadgeTheme.Black}
      className='fixed bottom-0 left-1/2 -translate-x-1/2 z-[105]'
      size={SentWithBonjoroBadgeSize.Large}
      rounded={SentWithBonjoroBadgeRounded.TopOnly}
      opacity={SentWithBonjoroBadgeOpacity.Medium}
      target='_blank'
      hideArrow
      shadow
      {...props}
    />
  );
};
